import { FC } from "react"
import { Alert, CircularProgress } from "@mui/material"
import { useParams } from "react-router-dom"
import { UserbotPage } from "./userbotPage"
import { TemplateEditor } from "../components"
import { useTemplateQuery } from "../store"
import { getApiErrorMessage } from "@/core/utils"

export const TemplateEditorPage: FC = () => {
  const { id } = useParams<{ id: string }>()
  const isNew = !id
  const { data, isFetching, isError, error } = useTemplateQuery(
    { id: id! },
    { skip: isNew },
  )

  return (
    <UserbotPage title={isNew ? "Новый шаблон" : "Редактирование шаблона"}>
      {isNew ? (
        <TemplateEditor />
      ) : (
        <>
          {isFetching && !data && <CircularProgress />}
          {isError && (
            <Alert severity="error">{getApiErrorMessage(error)}</Alert>
          )}
          {data && <TemplateEditor template={data} />}
        </>
      )}
    </UserbotPage>
  )
}
